import { Outlet, Navigate } from "react-router-dom";

const TestRoutes = () => {
  // Check sessionStorage flag
  const cameFromProfile = sessionStorage.getItem("cameFromProfile");

  return cameFromProfile ? <Outlet /> : <Navigate to="/myprofile" />;
};

export default TestRoutes;
